import axios from "axios";
import Swal from "sweetalert2";

const API_URL = "https://rscoreapi.azurewebsites.net/api/";
//const API_URL = "https://testrsapi.realtyspacehub.com/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

let inactivityTimeout;
let refreshInterval;
let lastActivityAt = Date.now();
let isRefreshingCookie = false;
const AUTH_PAGES = ["/login", "/forgot-password", "/forget-password", "/resetpassword"];
const FIVE_MINUTES = 5 * 60 * 1000;

function isAuthPage(pathname = "") {
  return AUTH_PAGES.includes(pathname.toLowerCase());
}

function resetInactivityTimer() {
  lastActivityAt = Date.now();

  if (inactivityTimeout) {
    clearTimeout(inactivityTimeout);
  }
  inactivityTimeout = setTimeout(() => {
    console.warn("User inactive for 5 minutes. Logging out...");
    showSessionExpiredAlert();
  }, FIVE_MINUTES);
}

async function refreshSessionCookie() {
  if (isRefreshingCookie || isAuthPage(window.location.pathname) || !localStorage.getItem("authUser")) {
    return;
  }

  isRefreshingCookie = true;
  try {
    await axiosApi.post("user/refresh-cookie", null, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    // Keep silent; regular auth handling remains through 401 flow.
  } finally {
    isRefreshingCookie = false;
  }
}

function setupRefreshCookieTimer() {
  if (refreshInterval) {
    return;
  }

  refreshInterval = setInterval(() => {
    const hasRecentActivity = Date.now() - lastActivityAt <= FIVE_MINUTES;
    if (hasRecentActivity) {
      //refreshSessionCookie();
    }
  }, FIVE_MINUTES);
}

export function setupInactivityTimer() {
  console.log("Attaching event listeners for inactivity timer.");
  window.addEventListener("mousemove", resetInactivityTimer);
  window.addEventListener("keydown", resetInactivityTimer);
  window.addEventListener("scroll", resetInactivityTimer);
  window.addEventListener("click", resetInactivityTimer);
  resetInactivityTimer();
  setupRefreshCookieTimer();
}

function showSessionExpiredAlert() {
  if (isAuthPage(window.location.pathname)) {
    return;
  }

  Swal.fire({
    title: "Session Expired",
    text: "Your session has expired. Press OK to return to the login page.",
    icon: "warning",
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    localStorage.clear();
    window.location.href = "/login";
  });
}


axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 Unauthorized - session expired or invalid
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized access. Session may have expired.");
      //showSessionExpiredAlert();
    }

    return Promise.reject(error);
  }
);

// Call this function after user login
if (localStorage.getItem("authUser")) {
  if (!isAuthPage(window.location.pathname)) {
    setupInactivityTimer();
  }
}

// HTTP methods using cookies for authentication
export async function get(url, config = {}) {
  return axiosApi
    .get(url, {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      withCredentials: true,
    })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      withCredentials: true,
    })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, data, {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      withCredentials: true,
    })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return axiosApi
    .delete(url, {
      ...config,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      withCredentials: true,
    })
    .then((response) => response.data);
}
